var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Typography, MenuItem, Grid, Paper, IconButton, Button, Divider } from '@mui/material';
import { Add as AddIcon, DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';
import { MODOS } from '../../../utils';
import { ROUTES, FUNCIONALIDADES, PAGINAS } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { BoxPrincipal, BoxBotoes } from '../../../components/form_box';
import Loading from '../../../components/loading';
import { useParams } from 'react-router-dom';
import { BotaoFechar } from '../../../components/botoes';
import { InputDados } from '../../../components/input_dados';
import { getRubricasLista, cadastrarRubrica, alterarRubrica, excluirRubrica, STATUS_API } from './rubricas_folha.service';
var MAX_DESCRICAO = 200;
export var RubricasFolhasEditar = function () {
    var _a = useAuth(), addMensagem = _a.addMensagem, getAcoesFuncionalidade = _a.getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.RUBRICAS_FOLHAS); }, [getAcoesFuncionalidade]);
    var modo = useParams().modo;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(true), LoadingInicio = _c[0], setLoadingInicio = _c[1];
    var _d = useState([]), Rubricas = _d[0], setRubricas = _d[1];
    var DESABILITAR_CAMPOS = (AcoesFuncionalidade === null || AcoesFuncionalidade === void 0 ? void 0 : AcoesFuncionalidade.ALTERAR) === false;
    useEffect(function () {
        carregar();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregar = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, getRubricasLista()];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == STATUS_API.ERRO) {
                        alert(Resp.Mensagem);
                    }
                    else if (Array.isArray(Resp)) {
                        setRubricas(Resp.map(function (r) {
                            var _a, _b, _c;
                            return ({
                                id: r.id,
                                descricao: (_a = r.descricao) !== null && _a !== void 0 ? _a : '',
                                permite_lancamento_manual: !!r.permite_lancamento_manual,
                                cumulativa: !!r.cumulativa,
                                situacao: (_b = r.situacao) !== null && _b !== void 0 ? _b : 'Ativo',
                                tipo_rubrica: (_c = r.tipo_rubrica) !== null && _c !== void 0 ? _c : 'PROVENTO',
                                em_uso: !!r.em_uso,
                                sistema: !!r.sistema,
                            });
                        }));
                    }
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var atualizarCampo = function (index, campo, valor) {
        setRubricas(function (prev) { return prev.map(function (r, i) {
            var _a;
            return (i === index ? __assign(__assign({}, r), (_a = {}, _a[campo] = valor, _a)) : r);
        }); });
    };
    var adicionarNova = function () {
        setRubricas(function (prev) { return __spreadArray([
            {
                descricao: '',
                permite_lancamento_manual: false,
                cumulativa: false,
                situacao: 'Ativo',
                tipo_rubrica: 'PROVENTO',
                em_uso: false,
                sistema: false,
                _novo: true,
            }
        ], prev, true); });
    };
    var validar = function (r) {
        if (!r.descricao || r.descricao.trim() == '') {
            alert('Descrição é obrigatória.');
            return false;
        }
        if (r.permite_lancamento_manual === undefined || r.permite_lancamento_manual === null) {
            alert('Permite Lançamento Manual é obrigatório.');
            return false;
        }
        if (!r.situacao) {
            alert('Situação é obrigatória.');
            return false;
        }
        if (!r.tipo_rubrica) {
            alert('Tipo de Rúbrica é obrigatório.');
            return false;
        }
        return true;
    };
    var salvar = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var r, payload, Resp, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    r = Rubricas[index];
                    if (!validar(r))
                        return [2 /*return*/];
                    // Cenário 04: edição de rubrica em uso exige confirmação.
                    if (!r._novo && r.em_uso) {
                        if (!confirm('Esta rubrica possui lançamentos vinculados. Deseja alterá-la ?'))
                            return [2 /*return*/];
                    }
                    payload = {
                        descricao: r.descricao.trim(),
                        permite_lancamento_manual: r.permite_lancamento_manual,
                        cumulativa: r.cumulativa,
                        situacao: r.situacao,
                        tipo_rubrica: r.tipo_rubrica,
                    };
                    setLoading(true);
                    if (!(r._novo || !r.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, cadastrarRubrica(payload)];
                case 1:
                    _a = _c.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, alterarRubrica(payload, String(r.id))];
                case 3:
                    _a = _c.sent();
                    _c.label = 4;
                case 4:
                    Resp = _a;
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === 'OK' || (Resp === null || Resp === void 0 ? void 0 : Resp.id)) {
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem(r._novo ? 'Rubrica cadastrada com sucesso.' : 'Rubrica alterada com sucesso.');
                        carregar();
                    }
                    else {
                        alert((_b = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _b !== void 0 ? _b : 'Erro ao salvar a rubrica.');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var inativar = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, alterarRubrica({ situacao: 'Inativo' }, String(id))];
                case 1:
                    Resp = _b.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === 'OK') {
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem('Rubrica alterada para Inativo.');
                        carregar();
                    }
                    else {
                        alert((_a = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _a !== void 0 ? _a : 'Erro ao inativar a rubrica.');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var excluir = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var r, Resp, msg;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    r = Rubricas[index];
                    // Card novo (não salvo) — apenas remove da tela.
                    if (r._novo || !r.id) {
                        setRubricas(function (prev) { return prev.filter(function (_, i) { return i !== index; }); });
                        return [2 /*return*/];
                    }
                    if (!confirm('Tem certeza que deseja excluir esta rubrica?'))
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, excluirRubrica(String(r.id))];
                case 1:
                    Resp = _b.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === 'OK') {
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem('Rubrica excluída com sucesso.');
                        carregar();
                        return [2 /*return*/];
                    }
                    msg = (_a = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _a !== void 0 ? _a : '';
                    if (msg.toLowerCase().includes('lançamentos vinculados') || msg.toLowerCase().includes('inativo')) {
                        if (confirm(msg)) {
                            inativar(r.id);
                        }
                    }
                    else {
                        alert(msg || 'Erro ao excluir a rubrica.');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(ContainerPainel, __assign({ modo: modo, pagina_acima: PAGINAS.RUBRICAS_FOLHAS, pagina_especifica_permissao: FUNCIONALIDADES.RUBRICAS_FOLHAS, link_pagina_acima: ROUTES.RUBRICAS_FOLHAS }, { children: _jsxs(BoxPrincipal, __assign({ sx: { width: '70%' } }, { children: [!LoadingInicio && (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, mb: 1 } }, { children: [_jsx(Typography, __assign({ variant: 'h6' }, { children: "Gest\u00E3o de Rubricas" })), _jsx(Button, __assign({ variant: 'contained', color: 'success', startIcon: _jsx(AddIcon, {}), onClick: adicionarNova, disabled: DESABILITAR_CAMPOS }, { children: "Novo" }))] })), Rubricas.length === 0 && (_jsx(Typography, __assign({ variant: 'body2', color: 'textSecondary', sx: { my: 3 } }, { children: "Nenhuma rubrica cadastrada. Clique em Novo para adicionar." }))), Rubricas.map(function (r, index) {
                            var _a, _b, _c;
                            return (_jsxs(Paper, __assign({ variant: 'outlined', sx: { p: 2, mb: 2, borderRadius: 2 } }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' } }, { children: [_jsx(Typography, __assign({ variant: 'caption', sx: { fontWeight: 700, color: '#374151' } }, { children: "Descri\u00E7\u00E3o *" })), _jsxs(Typography, __assign({ variant: 'caption', sx: { color: '#9ca3af' } }, { children: [(_b = (_a = r.descricao) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0, "/", MAX_DESCRICAO] }))] })), _jsx(InputDados, { id: "descricao-".concat(index), label: '', value: r.descricao, onChange: function (e) { return atualizarCampo(index, 'descricao', e.target.value.substring(0, MAX_DESCRICAO)); }, inputProps: { maxLength: MAX_DESCRICAO }, disabled: DESABILITAR_CAMPOS })] })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: "permite-".concat(index), label: 'Permite Lan\u00E7amento Manual', value: String(r.permite_lancamento_manual), onChange: function (e) { return atualizarCampo(index, 'permite_lancamento_manual', e.target.value === 'true'); }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: "cumulativa-".concat(index), label: 'Cumulativa', value: String(r.cumulativa), onChange: function (e) { return atualizarCampo(index, 'cumulativa', e.target.value === 'true'); }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: "situacao-".concat(index), label: 'Situa\u00E7\u00E3o', value: r.situacao, onChange: function (e) { return atualizarCampo(index, 'situacao', e.target.value); }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: "tipo-".concat(index), label: 'Tipo de R\u00FAbrica', value: r.tipo_rubrica, onChange: function (e) { return atualizarCampo(index, 'tipo_rubrica', e.target.value); }, 
                                                    // Tipo bloqueado na edição se houver uso.
                                                    disabled: DESABILITAR_CAMPOS || (!r._novo && r.em_uso) }, { children: [_jsx(MenuItem, __assign({ value: 'PROVENTO' }, { children: "PROVENTO" })), _jsx(MenuItem, __assign({ value: 'DESCONTO' }, { children: "DESCONTO" }))] })) }))] })), _jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, mt: 2 } }, { children: [_jsx(IconButton, __assign({ "aria-label": 'excluir', color: 'error', onClick: function () { return excluir(index); }, disabled: DESABILITAR_CAMPOS }, { children: _jsx(DeleteOutlineIcon, {}) })), _jsx(Button, __assign({ variant: 'contained', color: 'success', onClick: function () { return salvar(index); }, disabled: DESABILITAR_CAMPOS }, { children: "Salvar" }))] }))] }), (_c = r.id) !== null && _c !== void 0 ? _c : "novo-".concat(index)));
                        }), _jsx(Divider, { sx: { my: 2 } }), _jsx(BoxBotoes, { children: _jsx(BotaoFechar, { modo: modo !== null && modo !== void 0 ? modo : MODOS.VISUALIZAR, pagina: ROUTES.RUBRICAS_FOLHAS, label: 'Voltar' }) })] })), loading && _jsx(Loading, {})] })) })));
};
export default RubricasFolhasEditar;
